import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../Core/RichText';

import {
  StyledContainer,
  Block,
  Heading,
  Statement,
  StyledCtas,
} from './styles';

const StatementSection = ({ data = null, className = '' }) => {
  if (!data) return null;
  const {
    component,
    textAlignment,
    textColor,
    backgroundColor,
    heading,
    bodyCopy,
    ctas,
  } = data;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Heading>{children}</Heading>,
      [BLOCKS.HEADING_1]: (_, children) => <Heading>{children}</Heading>,
      [BLOCKS.HEADING_2]: (_, children) => <Heading>{children}</Heading>,
      [BLOCKS.HEADING_3]: (_, children) => <Heading>{children}</Heading>,
    },
  };

  const body = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Statement>{children}</Statement>,
    },
  };

  return (
    <StyledContainer
      $backgroundColor={backgroundColor}
      className={`${component} ${className}`}
    >
      <Block $textAlignment={textAlignment} $textColor={textColor}>
        {heading && <RichText document={heading} options={header} />}
        {bodyCopy && <RichText document={bodyCopy} options={body} />}
        {ctas && <StyledCtas ctas={ctas} alignment={textAlignment} />}
      </Block>
    </StyledContainer>
  );
};

StatementSection.propTypes = {
  data: PropTypes.oneOfType([PropTypes.shape(), PropTypes.bool]),
  className: PropTypes.string,
};

export default StatementSection;
